/**
 * Created by henian.xu on 2018/8/6.
 *
 */

export { default as Page } from './page.vue';
export { default as Container } from './container.vue';
export { default as PageNav } from './PageNav.vue';
export { default as PageBar } from './PageBar.vue';
